import { createContext, useContext } from 'react';

// SF-181: 'warning' is for a non-blocking outcome the player should notice but that isn't a
// rejected/failed action (a fizzle, a repelled spell) — distinct tone from 'failure'.
export type ToastType = 'success' | 'failure' | 'warning';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

export interface ToastContextValue {
  toasts: Toast[];
  addToast: (message: string, type: ToastType) => void;
  removeToast: (id: string) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}
